// extracted by mini-css-extract-plugin
export var callCard = "_nm-0";
export var callMessageButton = "_nm-1";
export var helpIcon = "_nm-3";
export var helpIconContainer = "_nm-4";
export var verticalDivider = "_nm-2";